export const procurementTr = {
  originals: {
    history: 'Sürüm geçmişini incele',
    search: 'Orijinallerde ara',
    sort: 'Sıralama',
    newest: 'Önce en yeni',
    oldest: 'Önce en eski',
    noResults: 'Aramayla eşleşen orijinal sürüm yok. Güncel sürüm kullanılabilir durumda kalır.',
    current: 'Güncel sürümü göster',
    xmlDownload: 'XML kanıtını indir',
    xmlChecksum: 'XML özeti',
    reviewedDownload: 'İncelenen orijinali indir',
    revision: 'Orijinal sürümü',
    version: 'Sürüm {{number}}',
    previous:
      'Önceki bir orijinali görüntülüyorsunuz. Onay, muhasebe önizlemesinde belirtilen güncel sürümü kullanır.',
    file: 'Yeni orijinal dosya',
    reason: 'Değiştirme gerekçesi',
    save: 'Orijinal sürümü kaydet',
    replace: 'Orijinali değiştir',
    add: 'Orijinal ekle',
    download: 'Orijinali indir',
    source: 'Kaynak',
    recorded: 'Arşivlenme tarihi',
    checksum: 'SHA-256 özeti',
    retained:
      'Önceki orijinaller saklanır. Dosya değiştirilince fatura yeniden incelemeye alınır ve mevcut onay önizlemeleri geçersiz olur.',
    electronicImmutable:
      'İçe aktarılan e-faturanın orijinali değiştirilmez. Düzeltilmiş e-fatura yeniden incelenip içe aktarılmalıdır.',
    legacy:
      'Bu orijinal önceki depolamadan gelir. Açıkça değiştirildiğinde önce eski dosya ayrı bir sürüm olarak arşivlenir; arşiv tarihi geçmişteki teslim alınma tarihi olarak gösterilmez.',
    downloadOnly:
      'Bu orijinali güvenli biçimde dosya olarak indirin; bu biçim için gömülü önizleme bulunmaz.',
    reasonRequired: 'Lütfen değiştirme gerekçesini açıklayın (en az 3 karakter).',
    reasonInvalid: 'Gerekçe en fazla 500 karakter olabilir.',
    fileRequired: 'Lütfen bir orijinal dosya seçin.',
    loadError: 'Orijinal geçmişi yüklenemedi.',
    invalidSource:
      'Orijinal kanıt eksik veya özeti ya da bağlantısı geçersiz. Lütfen orijinal dosyayı kontrol edin.',
    notEditable: 'Onaylanmış veya iptal edilmiş faturanın orijinali değiştirilemez.',
    immutable: 'Orijinal sürümler değiştirilmeden saklanır.',
    privateSource: 'Gelen fatura orijinalleri dahilidir ve herkese açık bağlantı verilemez.',
    reviewed: 'İncelenen orijinal',
    sources: {
      MANUAL_UPLOAD: 'Manuel yükleme',
      LEGACY_CAPTURE: 'Önceki depolamadan saklandı',
      ELECTRONIC_IMPORT: 'E-fatura içe aktarımı',
    },
  },
  orderStatus: {
    DRAFT: 'Taslak',
    SENT: 'Gönderildi',
    CONFIRMED: 'Onaylandı',
    PARTIALLY_RECEIVED: 'Kısmen alındı',
    RECEIVED: 'Tamamen alındı',
    BILLED: 'Faturalandırıldı',
    CANCELLED: 'İptal edildi',
  },
  receiptStatus: {
    DRAFT: 'Taslak',
    POSTED: 'Gönderildi',
    CANCELLED: 'İptal edildi',
  },
  qualityStatus: {
    ACCEPTED: 'Kabul edildi',
    DAMAGED_REJECTED: 'Hasarlı / reddedildi',
    UNDER_QUARANTINE: 'Karantina altında',
  },
  invoiceStatus: {
    DRAFT: 'İncelenmeyi bekliyor',
    MATCHED: 'Eşleşti',
    DISCREPANCY: 'Fiyat tutarsızlığı',
    APPROVED_FOR_PAYMENT: 'Ödeme için onaylandı',
    PAID: 'Ödendi',
    CANCELLED: 'İptal edildi',
  },
  matchStatus: {
    PERFECT_MATCH: 'Mükemmel uyum',
    TOLERANCE_ACCEPTED: 'Tolerans dahilinde',
    PRICE_MISMATCH: 'Fiyat uyuşmazlığı',
    QTY_MISMATCH: 'Miktar uyuşmazlığı',
    MANUALLY_OVERRIDDEN: 'Manuel olarak kabul edildi',
  },
  orders: {
    invalidNumber: 'Geçerli bir sayı girin; miktar 0’dan büyük olmalıdır.',
    invalidTax: '0 ile 100 arasında vergi oranı girin.',
    title: 'Satın alma siparişleri',
    subtitle: 'Tedarikçi siparişlerini oluşturun, gönderin ve takip edin.',
    cardTitle: 'Siparişe genel bakış',
    cardDescription: 'Teslimat durumu ve sipariş değeriyle birlikte tüm satın alma siparişleri.',
    create: 'Yeni satın alma siparişi',
    newReceipt: 'Mal kabul kaydet',
    searchPlaceholder: 'Sipariş numarasını veya tedarikçiyi arayın',
    error: 'Satınalma siparişleri yüklenemedi.',
    emptyTitle: 'Satın alma siparişi bulunamadı',
    emptyHint: 'Tedarik sürecini başlatmak için bir satınalma siparişi oluşturun.',
    columns: {
      number: 'Sipariş numarası',
      supplier: 'Tedarikçi',
      orderDate: 'Sipariş tarihi',
      delivery: 'Teslimat tarihi',
      status: 'Durum',
      total: 'Sipariş değeri',
      article: 'Ürün',
      quantity: 'Adet',
      unit: 'Birim',
      price: 'Satın alma fiyatı',
      tax: "KDV %'si",
      lineNet: 'Net',
      freeText: 'Serbest metin',
    },
    created: 'Satınalma siparişi {{number}} oluşturuldu.',
    saved: 'Satın alma siparişi kaydedildi.',
    loadError: 'Satın alma siparişi yüklenemedi.',
    newTitle: 'Yeni satın alma siparişi',
    editorHint: 'Satın alma siparişinin kalemleri, koşulları ve teslimat adresi.',
    pdf: "PDF'yi İndir",
    send: 'E-postayla gönder',
    confirm: 'Sipariş onayı alındı',
    confirmed: 'Satın alma siparişi onaylandı olarak işaretlendi.',
    cancel: 'Siparişi iptal et',
    cancelled: 'Satın alma siparişi iptal edildi.',
    cancelTitle: 'Satın alma siparişi {{number}} iptal edilsin mi?',
    cancelDescription:
      'Satın alma siparişi kalıcı olarak iptal edilecek ve daha sonra düzenlenemeyecek.',
    cancelReason: 'İptal nedeni',
    receiveGoods: 'Mal kabul kaydet',
    itemsTitle: 'Kalemler',
    itemsHint: 'Kademeli fiyatları veya serbest metin kalemleri bulunan tedarikçi ürünleri.',
    articlePlaceholder: 'Ürün ara',
    noSupplierProducts: 'Bu tedarikçiye hiçbir ürün atanmadı.',
    freeTextPlaceholder: 'Öğe açıklaması',
    removeItem: 'Öğeyi kaldır',
    addItem: 'Öğe ekle',
    net: 'Net',
    tax: 'KDV',
    gross: 'Brüt',
    headerTitle: 'Sipariş başlığı',
    headerHint: 'Tedarikçi, tarihler ve şartlar.',
    supplier: 'Tedarikçi',
    supplierPlaceholder: 'Tedarikçiyi ara',
    noSuppliers: 'Tedarikçi bulunamadı.',
    minimumOrderValue: 'Minimum sipariş değeri',
    deliveryTime: 'Teslim süresi',
    days: '{{count}} gün',
    expectedDelivery: 'Beklenen teslim tarihi',
    paymentTerms: 'Ödeme koşulları (gün)',
    incoterms: 'Incoterms',
    storageArea: 'Hedef depolama alanı',
    storageAreaHint: 'Mal kabul kaydedilirken önceden doldurulur.',
    notes: 'Notlar',
    email: {
      title: 'Satın alma siparişini gönder',
      description: 'Sipariş PDF olarak eklendi ve durum "Gönderildi" olarak ayarlandı.',
      to: 'Alıcı',
      subject: 'Konu',
      body: 'Mesaj',
      submit: 'Gönder',
      sent: 'Satın alma siparişi gönderildi.',
      defaultSubject: 'Satın alma siparişi {{number}}',
      defaultBody:
        'Merhaba,\n\nlütfen satın alma siparişimizi ekte bulabilirsiniz {{number}}.\n\nSaygılarımızla',
    },
  },
  receipts: {
    warehouseRequired: 'Bu konum için depoyu seçin. Tek başına bir etiket stok yerini belirlemez.',
    title: 'Mal kabulleri',
    subtitle: 'Kaydedilen ve açık mal girişlerine genel bakış.',
    cardTitle: 'Mal kabule genel bakış',
    cardDescription: 'Satın alma siparişi referanslarıyla birlikte kaydedilen tüm teslimatlar.',
    create: 'Mal kabul kaydet',
    searchPlaceholder: 'Makbuz, sipariş veya teslimat notu numarası',
    error: 'Mal girişleri yüklenemedi.',
    listEmptyTitle: 'Henüz mal girişi yok',
    listEmptyHint: 'Stokunuzu güncellemek için bir teslimat kaydedin.',
    columns: {
      number: 'Makbuz numarası',
      supplier: 'Tedarikçi',
      order: 'Satınalma siparişi',
      deliveryNote: 'Teslimat notu',
      date: 'Alınma tarihi',
      status: 'Durum',
    },
    terminalTitle: 'Mal kabul kaydet',
    terminalSubtitle:
      'Siparişi tarayın, miktarları doğrulayın ve stokları bağlayıcı olarak gönderin.',
    selectOrder: 'Satınalma siparişini seçin',
    selectOrderHint:
      'Sipariş numarasını tarayın veya açık satın alma siparişlerinden birini seçin.',
    scanOrder: 'Tarama sırası numarası',
    scanPlaceholder: 'ör. EK-2026-0001',
    openOrders: 'Satınalma siparişlerini aç',
    openOrdersPlaceholder: 'Sırayı seç',
    emptyTitle: 'Satın alma siparişi seçilmedi',
    emptyHint: 'Teslimat notu barkodunu tarayın veya bir satın alma siparişi seçin.',
    loadError: 'Sipariş kalemleri yüklenemedi.',
    positionsTitle: '{{number}} kalemleri',
    nothingOpen: 'Bu satın alma siparişinde açık miktar yok.',
    batchManaged: 'Toplu yönetim',
    open: 'Açık: {{quantity}} {{unit}}',
    quantityReceived: 'Alınan miktar',
    quantityInvalid: "Lütfen 0'dan büyük bir miktar girin.",
    batchNumber: 'Parti numarası',
    batchRequired: 'Toplu yönetilen ürünler için bir parti numarası zorunludur.',
    expiryDate: 'Önceki en iyi tarih',
    expiryRequired: 'Lütfen son kullanma tarihi girin.',
    storageLocation: 'Saklama kutusu / raf',
    storageLocationPlaceholder: 'ör. A-03-12',
    quality: 'Kalite',
    deliveryNoteTitle: 'Teslimat notu',
    deliveryNoteHint: 'Teslimat notu numarasını kaydedin ve bir tarama veya fotoğraf ekleyin.',
    deliveryNoteNumber: 'Teslimat notu numarası',
    storageArea: 'Depolama alanı',
    notes: 'Notlar',
    attachScan: 'Teslimat notunu tarayın veya yükleyin',
    noScan: 'Hiçbir belge eklenmedi',
    blocked: '{{count}} kalem henüz tamamlanmadı.',
    ready: '{{count}} öğe(ler)i yayınlanacak.',
    submit: 'Mal kabulü kaydet ve stoku güncelle',
    posted: '{{number}} numaralı mal kabul kaydedildi ve stok güncellendi.',
  },
  invoices: {
    metadataTitle: 'Muhasebe bilgilerini düzenle: {{number}}',
    importedMetadataHint:
      'Bu e-faturanın asıl tutarları ve satırları korunur. Burada alınma, hizmet, vade ve muhasebe bilgilerini düzenleyin.',
    metadataSaved: 'Muhasebe bilgileri kaydedildi. Fatura yeniden incelenmelidir.',
    metadataSaveFailed: 'Muhasebe bilgileri kaydedilemedi. Girdiğiniz bilgiler korunuyor.',
    importedSourceLocked:
      'İçe aktarılan fatura değerleri korunur. Muhasebe bilgilerini ayrı düzenleyin; farklı bir asıl fatura, incelenmiş yeni içe aktarım gerektirir.',

    validation: {
      summary: 'İşaretli alanları kontrol edin. Girdileriniz korunur.',
      supplier: 'Bir tedarikçi seçin.',
      invoiceNumber: '1 ile 60 karakter arasında bir fatura numarası girin.',
      date: 'Geçerli bir takvim tarihi girin.',
      currency: 'EUR gibi geçerli üç harfli bir para birimi kodu girin.',
      rate: 'En fazla 10 ondalık basamaklı pozitif döviz kuru girin.',
      source: '3 ile 240 karakter arasında doğrulanabilir kur kaynağı girin.',
      amount: 'En fazla 4 ondalık basamaklı geçerli bir tutar girin.',
      quantity: 'En fazla 6 ondalık basamaklı pozitif bir miktar girin.',
      percent: 'En fazla 6 ondalık basamakla 0 ile 100 arasında bir yüzde girin.',
      days: 'İzin verilen tam sayı olarak iskonto gününü girin.',
      description: '1 ile 200 karakter arasında bir açıklama girin.',
      decimalHint: 'Ondalık ayırıcı: nokta veya virgül. Binlik ayırıcı kullanmayın.',
    },
    editTitle: 'Gelen faturayı düzenle',
    editSubmit: 'Değişiklikleri kaydet',
    withoutOrder: 'Sipariş olmadan',
    optionalOrder: 'İsteğe bağlı. Sipariş seçildiğinde kalemleri kopyalanır.',
    invoiceReceivedDate: 'Faturanın alındığı tarih',
    serviceDate: 'Hizmet tarihi',
    accountingDates: 'Muhasebe tarihleri ve döviz kuru',
    accountingDatesHint:
      'Kayıt ve vergi tarihleri onayda kontrol edilir. Muhasebe kuru, yasal olarak gerekli vergi kurunun yerini almaz.',
    captureLoadError: 'Fatura kayıt ayarları yüklenemedi.',
    draftSaved: '{{number}} taslağı kaydedildi. Orijinali yeniden yükleyin veya taslağı açın.',
    retryUpload: 'Orijinali yeniden yükle',
    openDraft: 'Taslağı aç',
    title: 'Alış faturaları',
    subtitle: 'Alacaklıları vade tarihine ve nakit indirimi son tarihine göre izleyin.',
    cardTitle: 'Gelen faturalar',
    cardDescription: 'İnceleme ve ödeme durumuyla birlikte tüm tedarikçi faturaları.',
    create: 'Faturayı kaydet',
    createTitle: 'Alış faturası kaydet',
    createDescription:
      'Siparişe bağlı veya bağımsız fatura kaydedin ve inceleme için orijinal belgeyi ekleyin.',
    created: 'Fatura {{number}} kaydedildi.',
    searchPlaceholder: 'Fatura numarasını veya tedarikçiyi arayın',
    error: 'Alış faturaları yüklenemedi.',
    emptyTitle: 'Alış faturası bulunamadı',
    emptyHint: 'İncelemeyi başlatmak için bir tedarikçi faturası kaydedin.',
    blocked: 'Ödeme engellendi',
    order: 'Satınalma siparişi',
    orderPlaceholder: 'Sırayı seç',
    number: 'Fatura numarası',
    invoiceDate: 'Fatura tarihi',
    discountPercent: 'Nakit indirimi %',
    discountDays: 'İndirim günleri',
    document: 'Fatura belgesi (PDF veya tarama)',
    addItem: 'Öğe ekle',
    removeItem: 'Öğeyi kaldır',
    submit: 'Faturayı kaydet',
    discountHint: '{{count}} gün daha için nakit indirimi % {{percent}} mevcut',
    discountHint_one: 'Nakit indirimi %{{percent}} yalnızca bugün mevcut',
    discountGone: 'İndirim süresi doldu',
    kpi: {
      open: 'Açık tutar',
      overdue: 'Vadesi geçmiş',
      discrepancy: 'Tutarsızlıkla',
      discount: 'İndirimin süresi doluyor',
    },
    columns: {
      number: 'Fatura numarası',
      supplier: 'Tedarikçi',
      invoiceDate: 'Fatura tarihi',
      dueDate: 'Vade tarihi',
      discount: 'Nakit indirimi',
      status: 'Durum',
      gross: 'Brüt',
      description: 'Açıklama',
      quantity: 'Adet',
      unitPrice: 'Birim fiyatı',
      taxRate: "KDV %'si",
    },
  },
  match: {
    title: 'Üçlü maç {{number}}',
    loadError: 'Fatura eşleşmesi yüklenemedi.',
    run: 'Eşleşmeyi yeniden hesapla',
    clear: 'Tüm kalemler eşleşiyor.',
    discrepancies: '{{count}} öğe(ler)i sapıyor.',
    documentTitle: 'Tedarikçi faturası',
    documentError: 'Belge yüklenemedi.',
    noDocument: 'Hiçbir belge eklenmedi',
    noDocumentHint: 'Faturayı PDF olarak yükleyin veya burada incelemek için tarayın.',
    upload: 'Belgeyi yükle',
    uploaded: 'Belge saklandı.',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
    rotate: 'Döndür',
    reload: 'Yeniden yükle',
    tableTitle: 'Sipariş / teslimat / fatura',
    counts: '{{matched}} kesin · {{tolerance}} tolerans dahilinde · {{discrepancy}} sapan',
    columns: {
      position: 'Öğe',
      description: 'Açıklama',
      ordered: 'Sipariş Edildi',
      delivered: 'Teslim edildi',
      invoiced: 'Faturalandı',
      variance: 'Varyans',
      status: 'Durum',
    },
    totalVariance: 'Toplam varyans',
    approve: 'Ödemeyi onayla',
    approved: 'Fatura ödeme için onaylandı.',
    acceptTolerance: 'Toleransı manuel olarak kabul et',
    override: {
      title: 'Farkı manuel olarak kabul et',
      description: 'Bunun nedeni maç günlüğünde ve denetim kaydında saklanır.',
      reason: 'Sebep',
      submit: 'Farklılığı kabul et',
      saved: 'Farklılık kabul edildi.',
    },
    complaint: {
      action: 'Şikayet gönder',
      title: 'Tedarikçiye şikayet',
      description: 'Mesaj e-postayla gönderilir ve günlüğe kaydedilir.',
      to: 'E-posta adresi',
      subject: 'Konu',
      body: 'Mesaj',
      submit: 'Şikayet gönder',
      sent: 'Şikayet gönderildi.',
      defaultSubject: '{{number}} faturasına ilişkin sorgu',
      defaultBody:
        "Merhaba,\n\nFaturanızı {{number}} incelerken, satın alma siparişi ve mal girişiyle karşılaştırıldığında {{variance}}'de bir farklılık bulduk.\n\nLütfen durumu inceleyin ve bize düzeltilmiş bir fatura gönderin.\n\nSaygılarımızla",
    },
  },
} as const;
